export default function useInfiniteScroll(context, triggerRefName = "infiniteTrigger") {
  let observer = null;

  return {
    enableInfiniteScroll() {
      const trigger = context.$refs[triggerRefName];

      if (!trigger || typeof context.loadMore !== "function") return;

      observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          context.loadMore();
        }
      }, {
        root: null,
        rootMargin: "0px",
        threshold: 1.0,
      });

      observer.observe(trigger);
    },

    disableInfiniteScroll() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    },
  };
}
